let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("biRPG")).then(() => parcelRequire('gR3IA'));